let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bqXIu")).then(() => parcelRequire('1pgzA'));